import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

import { ConfirmationModalComponent } from '../components/confirmation-modal/confirmation-modal.component';
import { CopyEnclosureModalComponent } from '../../project-layer/components/copy-enclosure-modal/copy-enclosure-modal.component';

type Modals = ConfirmationModalComponent & CopyEnclosureModalComponent;

@Directive({
    selector: '[appClickOutsideEnclosure]',
    standalone: false
})
export class ClickOutsideEnclosuresDirective {
  @Input() leftSideMenu: HTMLElement;
  @Input() modals: Modals[];
  @Input() copyModals: Modals[];
  @Output() clickOutside = new EventEmitter();

  constructor(private readonly elementRef: ElementRef) { }

  @HostListener('document:click', ['$event.target'])
  public onClick(target: HTMLElement) {
    const clickedInsideParentElement = this.leftSideMenu.contains(target);
    const clickInsideModal = this.checkIfUserHasClickedOnOutsideOfModalWindow(this.modals.concat(this.copyModals), target);
    const clickedInside = this.elementRef.nativeElement.contains(target);

    if (!clickInsideModal && !clickedInsideParentElement && !clickedInside) {
      this.clickOutside.emit();
    }
  }

  private checkIfUserHasClickedOnOutsideOfModalWindow(modals: Modals[], target: HTMLElement): boolean {

    for (const modal of modals) {
      if (this.isElementPresented(modal, target) || this.isElementPresented(modal, target)) {
        return true;
      }
    }

    return false;
  }

  private isElementPresented(modal: ConfirmationModalComponent | CopyEnclosureModalComponent, target: HTMLElement) {
    return modal.modelEl.nativeElement.contains(target);
  }
}
